import React from 'react';

import * as OrgActions from 'actions/OrganizationActions';
import DataConnector from 'connect/DataConnector';
import {Member} from 'orgs/OrganizationConstants';
import EntityStore from 'stores/EntityStore';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import useOnMount from 'ui-library/hooks/useOnMount';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

interface ActivityLogUserSelectorProps {
  organizationId: string;
  selectedMember: Member | null;
  setSelectedMember: (member: Member) => void;
}

interface ActivityLogUserSelectorEnhancedProps {
  membersFromStore: Array<Member>;
}

class ActivityLogUserSelectorConnector extends DataConnector<
  ActivityLogUserSelectorProps,
  ActivityLogUserSelectorEnhancedProps
> {
  override shouldSubscribeToRedux = false;
  override stores = [EntityStore];

  enhanceProps(): ActivityLogUserSelectorEnhancedProps {
    const membersFromStore = this.entityStore().getMembersForGroup(this.props.organizationId) || [];
    return {membersFromStore};
  }
}

function ActivityLogUserSelector(
  props: ActivityLogUserSelectorProps & ActivityLogUserSelectorEnhancedProps
): JSX.Element {
  useOnMount(() => {
    OrgActions.fetchMembers(props.organizationId);
  });
  const membersById = props.membersFromStore.reduce<Record<string, Member>>((acc, member) => {
    acc[member.id] = member;
    return acc;
  }, {});

  return (
    <SelectDropdown
      disabled={props.membersFromStore.length === 0}
      displayName={props.selectedMember != null ? props.selectedMember.handle : 'Show All'}
      menu={
        <SearchableMenu
          onSelect={(value) => {
            props.setSelectedMember(membersById[value]);
          }}
          optionDatas={[
            {
              value: null,
              name: 'Show All',
            },
            ...props.membersFromStore.map((member) => ({value: member.id, name: member.handle})),
          ]}
          selectedValue={props.selectedMember?.id}
          width={MenuWidth.FULL}
        />
      }
    />
  );
}

export default ActivityLogUserSelectorConnector.connect(ActivityLogUserSelector);
